import { BaseContract } from './baseContract.js';
import { Web3Contract } from './web3Contract.js';
import { AElfContract } from './aelfContract.js';
export class ContractBasic extends BaseContract {
    constructor(options) {
        super(options);
        this.callContract = this.type === 'aelf' ? new AElfContract(options) : new Web3Contract(options);
    }
    callViewMethod(functionName, paramsOption, callOptions) {
        return this.callContract.callViewMethod(functionName, paramsOption, callOptions);
    }
    callSendMethod(functionName, account, paramsOption, sendOptions) {
        return this.callContract.callSendMethod(functionName, account, paramsOption, sendOptions);
    }
    encodedTx(functionName, paramsOption, callOptions) {
        return this.callContract.encodedTx(functionName, paramsOption, callOptions);
    }
}
